'use strict';

var Carousel = require('./lib/carousel');

module.exports = Carousel;



/*****************
 ** WEBPACK FOOTER
 ** ./~/nuka-carousel/index.js
 ** module id = 369
 ** module chunks = 0
 **/